<mat-sidenav-container fullscreen (backdropClick)="closeDetail()">
  <mat-sidenav #sidenav [opened]="detailOpen" position="end">
    <router-outlet name="detail" (activate)="detailOpen = true" (deactivate)="detailOpen = false"></router-outlet>
    <button (click)="closeDetail()"
      class="m-4 rounded-md border border-gray-300 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50">
      Close
    </button>
  </mat-sidenav>

  <div class="min-h-full bg-gray-100">

    <!-- ── Navigation bar (dark only) ───────────────────────────── -->
    <nav class="shadow" style="background: linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url('assets/bild5.jpg') center/cover no-repeat;">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div class="flex h-28 items-center justify-between border-b border-gray-500">

          <!-- Left: logo -->
          <div class="flex items-center shrink-0">
            <a [routerLink]="['/home']" class="bg-white rounded-md px-3 py-2 cursor-pointer">
              <img src="assets/logo-france.jpg" alt="French Rendez-Vous" class="h-16 w-auto" />
            </a>
          </div>

          <!-- Right: live system + profile (desktop) -->
          <div class="hidden md:flex items-center gap-3">

            <!-- Superuser cog (event configuration) -->
            <button *ngIf="isSuperuser" (click)="openEventConfig()" title="Event configuration"
              class="inline-flex items-center justify-center rounded-md bg-white/80 px-2.5 h-9
                     text-gray-700 shadow backdrop-blur-sm hover:bg-white/95 active:bg-white transition-colors duration-150">
              <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
              </svg>
            </button>

            <!-- Superuser badge (only visible to superusers) -->
            <span *ngIf="isSuperuser"
              class="inline-flex items-center rounded-md bg-amber-400/90 px-2.5 h-9 text-sm font-semibold text-gray-900 shadow">
              Superuser
            </span>

            <!-- Current event phase badge (all backend users) -->
            <span
              class="inline-flex items-center gap-2 rounded-md bg-white/80 px-2.5 h-9 text-sm font-semibold text-gray-800 shadow"
              [title]="activePhaseTip">
              <span class="h-2 w-2 rounded-full" [style.backgroundColor]="activePhaseColor"></span>
              {{ activePhaseLabel }}
            </span>

            <!-- Frontpage (public) — opens project root in a new tab -->
            <a href="/" target="_blank" rel="noopener" title="Open the public frontpage"
              class="inline-flex items-center gap-2 rounded-md bg-white/80 px-4 h-9
                     text-sm font-semibold text-gray-800 shadow backdrop-blur-sm
                     hover:bg-white/95 active:bg-white transition-colors duration-150">
              <svg class="h-4 w-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
              </svg>
              Frontpage
            </a>

            <!-- Live System button -->
            <button (click)="gotoLiveSystem()"
              class="inline-flex items-center gap-2 rounded-md bg-white/80 px-4 h-9
                     text-sm font-semibold text-gray-800 shadow backdrop-blur-sm
                     hover:bg-white/95 active:bg-white transition-colors duration-150">
              <span class="relative flex h-2 w-2">
                <span class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75"
                  [style.backgroundColor]="activePhaseColor"></span>
                <span class="relative inline-flex rounded-full h-2 w-2"
                  [style.backgroundColor]="activePhaseColor"></span>
              </span>
              Live System
              <svg class="h-3.5 w-3.5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
              </svg>
            </button>

            <!-- Profile dropdown -->
            <div class="relative profile-menu-container">
              <button (click)="toggleProfileMenu()"
                class="flex items-center rounded-full focus-visible:outline focus-visible:outline-2
                       focus-visible:outline-offset-2 focus-visible:outline-blue-500">
                <div class="h-8 w-8 rounded-full bg-blue-900 flex items-center justify-center
                            text-white text-xs font-semibold select-none overflow-hidden
                            outline outline-1 -outline-offset-1 outline-white/10">
                  <phuture-iavatar *ngIf="_profileImage" [src_image]="_profileImage" dimension="32" aClass="rounded-full"></phuture-iavatar>
                  <span *ngIf="!_profileImage">{{ _userName?.charAt(0)?.toUpperCase() }}</span>
                </div>
              </button>

              <!-- Dropdown panel -->
              <div *ngIf="profileMenuOpen"
                class="absolute right-0 mt-2 w-52 rounded-md bg-white py-1 shadow-lg
                       outline outline-1 outline-black/5 z-50">
                <div class="px-4 py-2 border-b border-gray-100">
                  <p class="text-sm font-medium text-gray-900 truncate">{{ _userName }}</p>
                  <p class="text-xs text-gray-500 truncate">{{ _userEmail }}</p>
                  <span class="mt-1.5 inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-xs font-semibold text-blue-800">
                    {{ roleLabel }}
                  </span>
                </div>
                <button (click)="logout()"
                  class="w-full flex items-center gap-2 px-4 py-2 text-sm text-gray-700
                         hover:bg-gray-100 transition-colors text-left">
                  <svg class="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75" />
                  </svg>
                  Sign out
                </button>
              </div>
            </div>
          </div>

          <!-- Mobile menu button -->
          <div class="-mr-2 flex md:hidden mobile-menu-container">
            <button (click)="mobileMenuOpen = !mobileMenuOpen"
              class="inline-flex items-center justify-center rounded-md p-2
                     text-gray-400 hover:bg-white/5 hover:text-white focus:outline-none">
              <svg *ngIf="!mobileMenuOpen" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
              </svg>
              <svg *ngIf="mobileMenuOpen" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

        </div>
      </div>

      <!-- Mobile menu panel -->
      <div *ngIf="mobileMenuOpen" class="border-t border-white/10 md:hidden mobile-menu-container">
        <div class="border-t border-white/10 pb-3 pt-4">
          <div class="flex items-center px-5">
            <div class="h-9 w-9 rounded-full bg-blue-900 flex items-center justify-center
                        text-white text-sm font-semibold shrink-0 overflow-hidden">
              <phuture-iavatar *ngIf="_profileImage" [src_image]="_profileImage" dimension="36" aClass="rounded-full"></phuture-iavatar>
              <span *ngIf="!_profileImage">{{ _userName?.charAt(0)?.toUpperCase() }}</span>
            </div>
            <div class="ml-3">
              <div class="text-sm font-medium text-white">{{ _userName }}</div>
              <div class="text-xs text-gray-400">{{ _userEmail }}</div>
              <span class="mt-1 inline-flex items-center gap-1.5 rounded-full bg-white/10 px-2 py-0.5 text-xs font-semibold text-gray-200">
                <span class="h-1.5 w-1.5 rounded-full" [style.backgroundColor]="activePhaseColor"></span>
                {{ roleLabel }} · {{ activePhaseLabel }}
              </span>
            </div>
          </div>
          <div class="mt-3 space-y-1 px-2">
            <button *ngIf="isSuperuser" (click)="openEventConfig()"
              class="block w-full text-left rounded-md px-3 py-2 text-sm font-medium
                     text-gray-400 hover:bg-white/5 hover:text-white">
              Event configuration →
            </button>
            <a href="/" target="_blank" rel="noopener"
              class="block w-full text-left rounded-md px-3 py-2 text-sm font-medium
                     text-gray-400 hover:bg-white/5 hover:text-white">
              Frontpage →
            </a>
            <button (click)="gotoLiveSystem()"
              class="block w-full text-left rounded-md px-3 py-2 text-sm font-medium
                     text-gray-400 hover:bg-white/5 hover:text-white">
              Live System →
            </button>
            <button (click)="logout()"
              class="block w-full text-left rounded-md px-3 py-2 text-sm font-medium
                     text-gray-400 hover:bg-white/5 hover:text-white">
              Sign out
            </button>
          </div>
        </div>
      </div>
    </nav>

    <!-- ── Main area (DashboardHome / EventConfig) ─────────────────── -->
    <router-outlet></router-outlet>

  </div><!-- /min-h-full -->
</mat-sidenav-container>
